// extracted by mini-css-extract-plugin
module.exports = {"minimalistCard":"styles_minimalistCard__3MXWw"};